module.exports = __webpack_public_path__ + "static/media/account-number.5637b33d.png";